import JWT from '@api/jwt'

// Token Search. This sets token. Invalidate token by changing tokenVersion:

const DAY = 24 * 60 * 60 * 1000
const YEAR = 365 * DAY
const tokenVersion = 'v2'

// sv — wersja sesji konta (security.session_version); zmiana hasła ją zwiększa i unieważnia starsze tokeny
const userToken = ({ _id, contact: { email }, security }, long, outdated) => {
    const validityTime = (outdated ? 0 : (long ? YEAR : DAY))
    const sv = Number.isInteger(security?.session_version) ? security.session_version : 0
    return JWT.encode({ _id, email, tokenVersion, sv }, validityTime)
}

export { tokenVersion }
export default userToken
